module.exports = __webpack_public_path__ + "img/logo-as-banner-bg-shape_blue.65b4f74.svg";